/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import SideNav from '../company-settings/side-nav/component';
import HRIntegrations from '../HR-integrations/component';
import PaymentIntegrations from '../payment-integrations/component';
import AccountIntegrations from '../account-integrations/component';
import { FormattedMessage, useIntl } from 'react-intl';
const CompanyIntegrations: React.FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  const intl = useIntl();
  return (
    <>
      <section className="pt-3">
        <div className="container">
          <div className="row">
            <SideNav />
            <div className="col-lg-8 col-xl-9">
              <div className="card shadow-sm border mb-5">
                <div className="card-header border-bottom">
                  <h4 className="card-header-title">
                    <i className="bi bi-plug mx-2"></i><FormattedMessage id="nav.integrations" />
                  </h4>
                </div>
                <div className="card-body border-bottom">
                  <div className="h5"><FormattedMessage id="company.hr.integration.title" /></div>
                  <HRIntegrations intl={intl}/>
                  {/* <div className="h5"><FormattedMessage id="company.account.integration.title" /></div>
                  <AccountIntegrations intl={intl} /> */}
                  <div className="h5 mt-3"><FormattedMessage id="company.payment.integration.title" /></div>
                  <PaymentIntegrations intl={intl}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CompanyIntegrations;
